import { useQuery } from "react-query";
import loyaltyService from "services/loyalty.services";

export const useLoyaltyConfig = (customerId, options = {}) => {
  return useQuery(
    ["loyaltyConfig", customerId],
    () => loyaltyService.getLoyaltyConfig(customerId),
    {
      enabled: !!customerId,
      keepPreviousData: true,
      staleTime: 60 * 60 * 1000,
      ...options,
    }
  );
};

export const useLoyaltyAccounts = (filterData, options = {}) => {
  return useQuery(
    ["loyaltyAccounts", { filterData }],
    () => loyaltyService.getLoyaltyAccounts(filterData),
    {
      keepPreviousData: true,
      staleTime: 0,
      cacheTime: 60 * 60 * 1000,
      ...options,
    }
  );
};

export const useLoyaltyAccount = (customerId, options = {}) => {
  return useQuery(
    ["loyaltyAccount", customerId],
    () => loyaltyService.getLoyaltyAccount(customerId),
    {
      enabled: !!customerId,
      keepPreviousData: true,
      ...options,
    }
  );
};

export const useLoyaltyTransactions = (filterData, options = {}) => {
  return useQuery(
    ["loyaltyTransactions", { filterData }],
    () => loyaltyService.getLoyaltyTransactions(filterData),
    {
      keepPreviousData: true,
      staleTime: 0,
      cacheTime: 60 * 60 * 1000,
      ...options,
    }
  );
};

export const useCashbackRequests = (filterData, options = {}) => {
  return useQuery(
    ["cashbackRequests", { filterData }],
    () => loyaltyService.getCashbackRequests(filterData),
    {
      keepPreviousData: true,
      staleTime: 0,
      ...options,
    }
  );
};

export const useMyLoyaltyAccount = (options = {}) => {
  return useQuery(
    ["myLoyaltyAccount"],
    () => loyaltyService.getMyLoyaltyAccount(),
    {
      keepPreviousData: true,
      staleTime: 60 * 1000,
      ...options,
    }
  );
};

export const useMyLoyaltyConfig = (options = {}) => {
  return useQuery(
    ["myLoyaltyConfig"],
    () => loyaltyService.getMyLoyaltyConfig(),
    {
      keepPreviousData: true,
      staleTime: 60 * 60 * 1000,
      ...options,
    }
  );
};

export const useMyLoyaltyTransactions = (filterData, options = {}) => {
  return useQuery(
    ["myLoyaltyTransactions", { filterData }],
    () => loyaltyService.getMyTransactions(filterData),
    {
      keepPreviousData: true,
      staleTime: 0,
      ...options,
    }
  );
};

export const useLoyaltyTiers = (options = {}) => {
  return useQuery(
    ["loyaltyTiers"],
    () => loyaltyService.getLoyaltyTiers(),
    {
      keepPreviousData: true,
      staleTime: 60 * 1000,
      ...options,
    }
  );
};

export const useLoyaltySummary = (options = {}) => {
  return useQuery(
    ["loyaltySummary"],
    () => loyaltyService.getLoyaltySummary(),
    {
      staleTime: 60 * 1000,
      ...options,
    }
  );
};

export const useMyLoyaltyDashboard = (options = {}) => {
  return useQuery(
    ["myLoyaltyDashboard"],
    () => loyaltyService.getMyLoyaltyDashboard(),
    {
      keepPreviousData: true,
      staleTime: 60 * 1000,
      ...options,
    }
  );
};

